import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';
import Logo from './image.png'
const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <Link className='logo' to="/dashboard">
                    <img src={Logo} alt="" />
                </Link>
            </div>

            {/* Bouton Burger - visible uniquement sur mobile via CSS */}
            <div className={`burger-menu ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>

            <ul className={`navbar-links ${isMenuOpen ? 'mobile-open' : ''}`}>
                <li>
                    <NavLink to="/dashboard" onClick={() => setIsMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
                        Dashboard
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/inventory" onClick={() => setIsMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
                        Inventaire
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/search" onClick={() => setIsMenuOpen(false)} className={({ isActive }) => isActive ? "active special-link" : "special-link"}>
                        🔍 Recherche Expert
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/add-product" onClick={() => setIsMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
                        + Ajouter
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/delivery-note" onClick={() => setIsMenuOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
                        Bon de livraison
                    </NavLink>
                </li>

                {/* Optionnel : Rappel déconnexion dans le menu mobile */}
                {/* <li className="mobile-only" onClick={handleLogout}>Déconnexion</li> */}
            </ul>

            {/* <div className="navbar-user" onClick={handleLogout} title="Déconnexion">
                <span className="user-name">Admin</span>
                <div className="user-avatar">A</div>
            </div> */}
        </nav>
    );
};

export default Navbar;
